<template>
  <div class="not-found-container">
    <div class="error-code">404</div>
    <h1>ບໍ່ພົບໜ້າທີ່ທ່ານກຳລັງຊອກຫາ</h1>
    <p>ຂໍອະໄພ, ທີ່ຢູ່ເວັບໄຊທີ່ທ່ານເຂົ້າເຖິງນັ້ນບໍ່ມີຢູ່ໃນລະບົບ ຫຼື ອາດຈະຖືກຍ້າຍໄປບ່ອນໃໝ່ແລ້ວ.</p>
    <router-link to="/home/dashboard" class="back-home-btn">
      ກັບຄືນໜ້າຫຼັກ
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'NotFoundPage'
}
</script>

<style scoped>
.not-found-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: #f8fafc;
  padding: 20px;
}

.error-code {
  font-size: 120px;
  font-weight: 800;
  color: #003F8A;
  line-height: 1;
  margin-bottom: 20px;
  text-shadow: 4px 4px 0px #e2e8f0;
}

h1 {
  font-size: 24px;
  color: #1a202c;
  margin-bottom: 12px;
}

p {
  color: #64748b;
  margin-bottom: 30px;
  max-width: 400px;
}

.back-home-btn {
  background-color: #003F8A;
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  transition: background-color 0.2s;
}

.back-home-btn:hover {
  background-color: #1565C0;
}
</style>